import { portfolioData } from '../../../mocks/portfolio';

export default function Hero() {
  const { hero } = portfolioData;

  const scrollToProjects = () => {
    const projectsSection = document.getElementById('projects');
    if (projectsSection) {
      projectsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToAbout = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-[#faf7f2] via-[#f5ede0] to-[#ede4d8]">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_41a99d48f362200d490db0b5c258d976_ff9e5df0.jpg"
          alt="background"
          className="w-full h-full object-cover object-top"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#faf7f2]/75 via-[#f5ede0]/60 to-[#ede4d8]/70"></div>
      </div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="flex items-center justify-between gap-12">
          {/* Left: Text Content */}
          <div className="max-w-2xl flex-1">
            {/* Label */}
            <div className="inline-block mb-8">
              <span className="text-[#8a6a4a] text-sm tracking-widest uppercase font-light">
                {hero.label}
              </span>
            </div>

            {/* Main Title */}
            <div className="space-y-4 mb-12">
              <h1 className="text-[#1a1a1a] font-black text-8xl lg:text-9xl leading-none tracking-tight">
                {hero.name.split(' ')[0]}
              </h1>
              <h2 className="text-[#6b4f35] font-serif italic text-6xl lg:text-7xl leading-none">
                {hero.name.split(' ')[1]}
              </h2>
              <p className="text-[#5a5a5a] text-4xl lg:text-5xl font-light leading-tight">
                {hero.field}
              </p>
            </div>

            {/* Description */}
            <p className="text-[#6a6a6a] text-xl leading-relaxed max-w-2xl mb-12">
              {hero.description}
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-6">
              <button 
                onClick={scrollToProjects}
                className="bg-[#3d2b1f] text-white px-10 py-4 rounded-lg font-semibold text-lg hover:bg-[#5a3d2b] transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                作品を見る
              </button>
              <button 
                onClick={scrollToAbout}
                className="bg-transparent border-2 border-[#3d2b1f] text-[#3d2b1f] px-10 py-4 rounded-lg font-semibold text-lg hover:bg-[#3d2b1f] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                About Me
              </button>
            </div>
          </div>

          {/* Right: Portrait Image */}
          <div className="hidden lg:flex flex-shrink-0 items-center justify-center">
            <div className="relative w-[420px] h-[520px]">
              {/* Decorative frame */}
              <div className="absolute -top-4 -right-4 w-full h-full rounded-2xl border-2 border-[#c9a87c]/40"></div>
              <div className="absolute -bottom-4 -left-4 w-full h-full rounded-2xl bg-[#e8d5bc]/30"></div>
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20creative%20designer%20portrait%2C%20young%20professional%20woman%20sitting%20at%20modern%20desk%20with%20design%20tools%2C%20warm%20studio%20lighting%2C%20soft%20bokeh%20background%2C%20artistic%20workspace%20atmosphere%2C%20cream%20and%20amber%20tones%2C%20sophisticated%20minimalist%20style%2C%20high%20quality%20photography&width=420&height=520&seq=hero-portrait-001&orientation=portrait"
                alt="Portfolio portrait"
                className="relative z-10 w-full h-full object-cover object-top rounded-2xl shadow-2xl"
              />
              {/* Floating badge */}
              <div className="absolute z-20 -bottom-6 -left-6 bg-white rounded-xl shadow-lg px-5 py-3 flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-[#3d2b1f] rounded-full">
                  <i className="ri-award-line text-white text-sm"></i>
                </div>
                <div>
                  <p className="text-[#1a1a1a] font-bold text-sm leading-none">5+ Years</p>
                  <p className="text-[#8a6a4a] text-xs mt-0.5">Experience</p>
                </div>
              </div>
              {/* Floating tag */}
              <div className="absolute z-20 -top-4 -right-6 bg-[#3d2b1f] text-white rounded-xl shadow-lg px-4 py-2">
                <p className="text-xs font-semibold tracking-wide">✦ Creative</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce cursor-pointer" onClick={scrollToProjects}>
        <i className="ri-arrow-down-line text-[#3d2b1f] text-3xl"></i>
      </div>
    </section>
  );
}